// components/StockHistoryTable.jsx
import React from "react";
import moment from "moment";
import {
    Box,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Divider,
} from "@mui/material";

function formatNumber(n) {
    if (n === null || n === undefined) return "-";
    const num = Number(n);
    if (Number.isNaN(num)) return String(n);
    return num.toLocaleString();
}

export default function StockHistoryTable({ rows = [], loading = false }) {
    return (
        <Box>

            <Divider sx={{ mb: 2 }} />

            {loading ? (
                <Typography variant="body2" color="text.secondary">
                    Loading...
                </Typography>
            ) : rows.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                    No stock history
                </Typography>
            ) : (
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700 }}>Modified</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Admin</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Stock</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Old Val</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>New Val</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows?.map((v, idx) => {
                            const modified = v.createdDate
                                ? moment(v.createdDate).format("DD/MM/YYYY HH:mm")
                                : "-";

                            const admin =
                                v.adminName ||
                                v.admin?.name ||
                                v.updatedBy?.name ||
                                v.createdBy?.name ||
                                "System";

                            const stock = `${formatNumber(v.value)}`

                            const oldVal = `${formatNumber(v.balance)}`;
                            const newVal = `${formatNumber(v.endingBalance)}`;

                            return (
                                <TableRow key={idx}>
                                    <TableCell>{modified}</TableCell>
                                    <TableCell>{admin}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{stock}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{oldVal}</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{newVal}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            )}
        </Box>
    );
}